import React, { useState } from 'react';
import NotificationsAlert from '../../services/NotificationsAlert';
import Conect from '../../../Api/Conect.js';
import { LuRefreshCw } from "react-icons/lu";
import { MdCreateNewFolder } from "react-icons/md";
import { FaCloudUploadAlt, FaHome } from "react-icons/fa";
import './TopBar.css';

const TopBar = ({ token, access, uploadProgress, currentPath, onOpenUpload, onHome, onFolderCreated, onRefresh }) => {
  const [newFolderName, setNewFolderName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false); // Controla o estado do modal

  const handleCreateFolder = async () => {
    if (!newFolderName) {
      NotificationsAlert("warning", "Atenção", "Nome da pasta não pode estar vazio");
      return;
    }

    const response = await Conect.post(`/api/directory`, {
      folderName: newFolderName,
      parentPath: currentPath,
    });

    if (response.data.error) {
      NotificationsAlert("error", "Erro", response.data.msg);
    } else {
      NotificationsAlert("success", "Sucesso", response.data.msg);
      setNewFolderName(''); // Limpar o nome da pasta
      setIsModalOpen(false); // Fecha o modal
      onFolderCreated(); // Chama a função de callback para atualizar a lista de arquivos
    }
  };

  // Abre o modal
  const openModal = () => {
    setIsModalOpen(true);
    console.log("open")
  };

  // Fecha o modal
  const closeModal = () => {
    setIsModalOpen(false);
    setNewFolderName(''); // Limpar o nome da pasta ao fechar o modal
  };

  return (
    <div className="top-bar">
      <div className="create-folder">
        <button style={{ backgroundColor: "#4C3971", marginLeft: access === 5 && "5%" }} onClick={onHome}><FaHome style={{ color: "#FFF", fontSize: 22 }} /></button>
        <button style={{ backgroundColor: "#4C3971", marginLeft: access === 5 && "5%" }} onClick={onRefresh}><LuRefreshCw style={{ color: "#FFF", fontSize: 22 }} /></button>

        {access <= 5 && !["", "/Usuario"].includes(currentPath) && (
          <button style={{ backgroundColor: "#4C3971" }} onClick={onOpenUpload}>
            <FaCloudUploadAlt style={{ color: "#00BFFF", fontSize: 24 }} />
          </button>
        )}

        {access <= 2 && !["", "/Usuario"].includes(currentPath) && (
          <div>
            <button className='btncreate' onClick={openModal}>
              <MdCreateNewFolder style={{ fontSize: 22 }} />
            </button>
          </div>
        )}

        {uploadProgress > 0 && (
          <div>
            <div>Progresso: {uploadProgress}%</div>
            <div
              style={{
                width: `${uploadProgress}%`,
                height: '10px',
                backgroundColor: '#00BFFF',
              }}
            />
          </div>
        )}
        {
          currentPath !== "" &&
          <div style={{ backgroundColor: "#4C3971", marginLeft: "0.1%", paddingLeft: "0.5%", paddingRight: "0.5%", paddingTop: "0.5%", paddingBottom: "0.5%", borderRadius: "5px" }}>{currentPath}</div>
        }
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-create">
          <div className="modal-content-create">
            <span className="close-create" onClick={closeModal}>&times;</span>
            <h2>Criar nova pasta</h2>
            <input
              type="text"
              placeholder="Nome da nova pasta"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
            />
            <button onClick={handleCreateFolder}>Criar Pasta</button>
            <button onClick={closeModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopBar;
